export default __webpack_public_path__ + "static/media/AE13.f5500ddd.jpg";